module.exports = __webpack_public_path__ + "img/0S6A0283.d78511d9.jpg";